import { useRegionHookQuery } from './graphql.v3.generated';

export type Region = {
  id: string
  phoneCode: string
  // Phone length without phone code
  phoneLength: number
  phoneMaxLength: number
  phoneCheckRegexp: string
  currencyName: string
};

export const useRegion = (): Region | { [K in keyof Region]?: undefined } => {
  const { data } = useRegionHookQuery();
  return data?.region ? data.region : {};
};
